// Portfolio: websites, mobile apps and browser extensions built by the team.
// Admin, login and internal dashboard links are intentionally not listed.
export const PORTFOLIO = [
  {
    "name": "WAY XPRESS Bhopal",
    "tag": "",
    "url": "https://wayxpressbhopal.in/",
    "category": "Websites"
  },
  {
    "name": "RigorField",
    "tag": "",
    "url": "https://rigorfield.com/",
    "category": "Websites"
  },
  {
    "name": "Trivo Real Estate",
    "tag": "",
    "url": "https://trivorealestate.com/",
    "category": "Websites"
  },
  {
    "name": "CareFrame Solution",
    "tag": "",
    "url": "https://careframesolution.com/",
    "category": "Websites"
  },
  {
    "name": "The Developer Bench",
    "tag": "",
    "url": "https://thedeveloperbench.com/",
    "category": "Websites"
  },
  {
    "name": "WedFirst",
    "tag": "",
    "url": "https://wedfirst.com/",
    "category": "Websites"
  },
  {
    "name": "GP Ambulga",
    "tag": "",
    "url": "https://gpambulga.com/",
    "category": "Websites"
  },
  {
    "name": "Marketing Tech",
    "tag": "",
    "url": "https://marketingtech.in/",
    "category": "Websites"
  },
  {
    "name": "MapVanta",
    "tag": "",
    "url": "https://mapvanta.com/",
    "category": "Websites"
  },
  {
    "name": "Lead Mappo",
    "tag": "",
    "url": "https://leadmappo.com/",
    "category": "Websites"
  },
  {
    "name": "Ayush Thakur Fitness",
    "tag": "",
    "url": "https://atf.ayushthakurfitness.com/",
    "category": "Websites"
  },
  {
    "name": "Codelume IT Solution",
    "tag": "",
    "url": "https://codelumeitsolution.com/",
    "category": "Websites"
  },
  {
    "name": "WebBox Software",
    "tag": "",
    "url": "https://webboxsoftware.com/",
    "category": "Websites"
  },
  {
    "name": "Web Dev Provider",
    "tag": "",
    "url": "https://webdevprovider.in/",
    "category": "Websites"
  },
  {
    "name": "RS Grand",
    "tag": "",
    "url": "https://rsgrand.in/",
    "category": "Websites"
  },
  {
    "name": "Gupta Innovations",
    "tag": "",
    "url": "https://guptainnovations.com/",
    "category": "Websites"
  },
  {
    "name": "Future Web Devs",
    "tag": "",
    "url": "https://futurewebdevs.com/",
    "category": "Websites"
  },
  {
    "name": "Pure Pack India",
    "tag": "",
    "url": "https://purepackindia.com/",
    "category": "Websites"
  },
  {
    "name": "Soie de Brij",
    "tag": "",
    "url": "https://soiedebrij.com/",
    "category": "Websites"
  },
  {
    "name": "StratAnalyze",
    "tag": "",
    "url": "https://stratanalyze.com/",
    "category": "Websites"
  },
  {
    "name": "DefineRight",
    "tag": "",
    "url": "https://defineright.com/",
    "category": "Websites"
  },
  {
    "name": "Vansh Technologies",
    "tag": "",
    "url": "https://vanshtechnologies.in/",
    "category": "Websites"
  },
  {
    "name": "CodeTunix",
    "tag": "",
    "url": "https://codetunix.com/",
    "category": "Websites"
  },
  {
    "name": "Chandrabhan Singh",
    "tag": "",
    "url": "https://chandrabhansingh.in/",
    "category": "Websites"
  },
  {
    "name": "Rekhadeep Tech Systems",
    "tag": "",
    "url": "https://rekhadeeptechsystems.com/",
    "category": "Websites"
  },
  {
    "name": "Royal Glass House",
    "tag": "",
    "url": "https://royalglasshouse.in/",
    "category": "Websites"
  },
  {
    "name": "Gugale Hospital",
    "tag": "",
    "url": "https://gugalehospital.com/",
    "category": "Websites"
  },
  {
    "name": "Mobility Electrified",
    "tag": "",
    "url": "https://mobilityelectrified.com/",
    "category": "Websites"
  },
  {
    "name": "Craft Haus Taproom",
    "tag": "",
    "url": "https://www.crafthaustaproom.com/",
    "category": "Websites"
  },
  {
    "name": "Shri Grow",
    "tag": "",
    "url": "https://shrigrow.com/",
    "category": "Websites"
  },
  {
    "name": "AlphaIT247",
    "tag": "",
    "url": "https://alphait247.com/",
    "category": "Websites"
  },
  {
    "name": "Industry Samurai Awards",
    "tag": "",
    "url": "https://industrysamurai.com/",
    "category": "Websites"
  },
  {
    "name": "R.N Motegaunkar School",
    "tag": "",
    "url": "https://rnmotegaonkarschool.com/",
    "category": "Websites"
  },
  {
    "name": "RCC Pattern",
    "tag": "Coaching Institute",
    "url": "https://rccpattern.com/",
    "category": "Websites"
  },
  {
    "name": "Gem Sisters Shop",
    "tag": "",
    "url": "https://gemsisters.shop/",
    "category": "Websites"
  },
  {
    "name": "Narayani Impex",
    "tag": "",
    "url": "https://narayaniimpex.in/",
    "category": "Websites"
  },
  {
    "name": "MP Taxi",
    "tag": "",
    "url": "https://mptaxi.in/",
    "category": "Websites"
  },
  {
    "name": "Renuka Public School",
    "tag": "",
    "url": "https://renukapublicschools.com/",
    "category": "Websites"
  },
  {
    "name": "Ask To CA",
    "tag": "CA Services",
    "url": "https://asktoca.in/",
    "category": "Websites"
  },
  {
    "name": "Shivraj Ragunath Motegaonkar",
    "tag": "Education",
    "url": "https://shivrajmotegaonkar.com/",
    "category": "Websites"
  },
  {
    "name": "Lending Square Group",
    "tag": "Financial Services",
    "url": "https://lendingsquaregroup.com/",
    "category": "Websites"
  },
  {
    "name": "Urban Team",
    "tag": "Real Estate (Australia)",
    "url": "https://urbanteam.com/",
    "category": "Websites"
  },
  {
    "name": "Handyman Work Melbourne (Australia)",
    "tag": "",
    "url": "https://handymanworkmelbourne.com.au/",
    "category": "Websites"
  },
  {
    "name": "Menocore",
    "tag": "Health & Wellness",
    "url": "https://menocore.in/",
    "category": "Websites"
  },
  {
    "name": "Ads By G5",
    "tag": "Digital Marketing",
    "url": "https://adsbyg5.com/",
    "category": "Websites"
  },
  {
    "name": "Gati Royal",
    "tag": "Logistics",
    "url": "https://gatiroyal.com/",
    "category": "Websites"
  },
  {
    "name": "Max Household",
    "tag": "",
    "url": "https://maxhousehold.in/",
    "category": "Websites"
  },
  {
    "name": "OSM Stays",
    "tag": "Hospitality",
    "url": "https://osmstays.com/",
    "category": "Websites"
  },
  {
    "name": "Master Locksmiths Directory (Australia)",
    "tag": "",
    "url": "https://masterlocksmithsmemberdirectory.com.au/",
    "category": "Websites"
  },
  {
    "name": "Mobile Savvy",
    "tag": "",
    "url": "https://mobilesavvy.ca/",
    "category": "Websites"
  },
  {
    "name": "ORO Vault",
    "tag": "",
    "url": "http://www.oro-vault.in/",
    "category": "Websites"
  },
  {
    "name": "WAY XPRESS Packers & Movers",
    "tag": "",
    "url": "https://wayxpress.in/",
    "category": "Websites"
  },
  {
    "name": "Sanveer Home Relocation",
    "tag": "",
    "url": "https://sanveerhomerelocation.in/",
    "category": "Websites"
  },
  {
    "name": "Dhakad Enterprises",
    "tag": "",
    "url": "https://dhakadenterprises.in/",
    "category": "Websites"
  },
  {
    "name": "Prestige Painters Hawthorn",
    "tag": "",
    "url": "https://paintershawthorn.com.au/",
    "category": "Websites"
  },
  {
    "name": "SMBI",
    "tag": "",
    "url": "https://smbi.in/",
    "category": "Websites"
  },
  {
    "name": "Machine Insider Design",
    "tag": "",
    "url": "https://machineinsider.com/",
    "category": "Websites"
  },
  {
    "name": "Ayesha Banerjee",
    "tag": "",
    "url": "https://ayeshabanerjeeofficial.com/",
    "category": "Websites"
  },
  {
    "name": "Business Garh",
    "tag": "",
    "url": "https://businessgarh.in/",
    "category": "Websites"
  },
  {
    "name": "Whole Care Foundation",
    "tag": "",
    "url": "https://wholecarefoundation.com/",
    "category": "Websites"
  },
  {
    "name": "Link Holidays",
    "tag": "",
    "url": "https://linkholidays.com.au/",
    "category": "Websites"
  },
  {
    "name": "Sunil Madhav",
    "tag": "",
    "url": "https://sunilmadhavs.world/",
    "category": "Websites"
  },
  {
    "name": "Himantika PT And Construction",
    "tag": "",
    "url": "https://hptndconst.com/",
    "category": "Websites"
  },
  {
    "name": "Vinayak Traders",
    "tag": "",
    "url": "https://vtuniforms.com/",
    "category": "Websites"
  },
  {
    "name": "LinkWISE Technologies",
    "tag": "",
    "url": "https://linkwise.com.au/",
    "category": "Websites"
  },
  {
    "name": "Smart Global Tools",
    "tag": "",
    "url": "https://smartglobaltools.com/",
    "category": "Websites"
  },
  {
    "name": "Griha Pravesh Developer",
    "tag": "",
    "url": "https://grihapraveshdeveloper.com/",
    "category": "Websites"
  },
  {
    "name": "Zell Move",
    "tag": "",
    "url": "https://zellmove.com/",
    "category": "Websites"
  },
  {
    "name": "Zell Move UK",
    "tag": "",
    "url": "https://zellmove.co.uk/",
    "category": "Websites"
  },
  {
    "name": "Zell Move IE",
    "tag": "",
    "url": "https://zellmove.ie/",
    "category": "Websites"
  },
  {
    "name": "Fit With Reshmi",
    "tag": "",
    "url": "https://go.fitwithreshmi.com/",
    "category": "Websites"
  },
  {
    "name": "B-Town Connect",
    "tag": "",
    "url": "https://btownconnect.com/",
    "category": "Websites"
  },
  {
    "name": "Manya Matrimony",
    "tag": "",
    "url": "https://manyamatrimony.com/",
    "category": "Websites"
  },
  {
    "name": "Smart Property Links",
    "tag": "",
    "url": "https://splinksmp.com/",
    "category": "Websites"
  },
  {
    "name": "Algotrivo Technologies",
    "tag": "",
    "url": "https://algotrivo.com/",
    "category": "Websites"
  },
  {
    "name": "RCC Pattern Support System",
    "tag": "",
    "url": "https://support.rccpattern.com/",
    "category": "Websites"
  },
  {
    "name": "Fresh Farmse",
    "tag": "Grocery Delivery",
    "url": "https://freshfarmse.com/",
    "category": "Websites"
  },
  {
    "name": "Parda Sansar",
    "tag": "Curtains Store",
    "url": "https://pardasansar.in/",
    "category": "Websites"
  },
  {
    "name": "Santarms",
    "tag": "Handicrafts",
    "url": "https://santarms.com/",
    "category": "Websites"
  },
  {
    "name": "Georgina’s Kitchen",
    "tag": "",
    "url": "https://georginaskitchen.com/",
    "category": "Websites"
  },
  {
    "name": "Cure by Design",
    "tag": "Hemp Wellness",
    "url": "https://curebydesign.in/",
    "category": "Websites"
  },
  {
    "name": "Incense Works",
    "tag": "Aromatherapy",
    "url": "https://incense.works/",
    "category": "Websites"
  },
  {
    "name": "BYD CLRS",
    "tag": "Fashion Brand",
    "url": "https://bydclrs.com/",
    "category": "Websites"
  },
  {
    "name": "Moonlight Crystals",
    "tag": "Australia",
    "url": "https://moonlightcrystals.com.au/",
    "category": "Websites"
  },
  {
    "name": "Sri Shankarlal Jewellers",
    "tag": "",
    "url": "https://srishankarlaljewellers.com/",
    "category": "Websites"
  },
  {
    "name": "Super Deal Outlet",
    "tag": "USA",
    "url": "https://superdealoutlet.com/",
    "category": "Websites"
  },
  {
    "name": "Ishwarah",
    "tag": "Luxury Fashion",
    "url": "https://ishwarah.com/",
    "category": "Websites"
  },
  {
    "name": "Furnikraft",
    "tag": "",
    "url": "https://furnikraft.com/",
    "category": "Websites"
  },
  {
    "name": "Feroall Cookware",
    "tag": "",
    "url": "https://feroallcookware.com/",
    "category": "Websites"
  },
  {
    "name": "Fleur du Luxe",
    "tag": "Luxury Retail (UK)",
    "url": "https://fleurduluxe.com/",
    "category": "Websites"
  },
  {
    "name": "Link Mart",
    "tag": "",
    "url": "https://linkmart.com.au/",
    "category": "Websites"
  },
  {
    "name": "SelSimpl",
    "tag": "",
    "url": "https://selsimpl.com/",
    "category": "Websites"
  },
  {
    "name": "Mega Home Furniture",
    "tag": "",
    "url": "https://megahomefurniture.in/",
    "category": "Websites"
  },
  {
    "name": "Bath & Being",
    "tag": "",
    "url": "https://bathandbeing.com/",
    "category": "Websites"
  },
  {
    "name": "Premiere Foods",
    "tag": "",
    "url": "https://premierefoods.in/",
    "category": "Websites"
  },
  {
    "name": "Sattva Essence Organics",
    "tag": "",
    "url": "https://sattvaessenceorganics.com/",
    "category": "Websites"
  },
  {
    "name": "CnC Moments",
    "tag": "",
    "url": "https://cncmoments.com/",
    "category": "Websites"
  },
  {
    "name": "ClinkChuz",
    "tag": "",
    "url": "https://clinkchuz.com/",
    "category": "Websites"
  },
  {
    "name": "Sri Anantha Padmanabha Swamy Pharma",
    "tag": "",
    "url": "https://sriapsps.com/",
    "category": "Websites"
  },
  {
    "name": "Nasaka RO Services",
    "tag": "",
    "url": "https://nasakaroservices.in/",
    "category": "Websites"
  },
  {
    "name": "Trikamchanda Traders",
    "tag": "",
    "url": "https://trikopolymers.com/",
    "category": "Websites"
  },
  {
    "name": "Wisdom Consultancy RKDF",
    "tag": "",
    "url": "http://thewisdomconsultancy.in/",
    "category": "Websites"
  },
  {
    "name": "Ratana Realty",
    "tag": "",
    "url": "https://ratanarealty.com/",
    "category": "Websites"
  },
  {
    "name": "Juris Hour",
    "tag": "",
    "url": "https://jurishour.in/",
    "category": "Websites"
  },
  {
    "name": "Falcon Nest Interiors",
    "tag": "",
    "url": "https://falconnestinteriors.com/",
    "category": "Websites"
  },
  {
    "name": "Goodwill Associates",
    "tag": "",
    "url": "https://goodwillassociates.in/",
    "category": "Websites"
  },
  {
    "name": "Singapore Maths",
    "tag": "",
    "url": "https://singaporemathsjt.com/",
    "category": "Websites"
  },
  {
    "name": "Microwin Information Technology",
    "tag": "",
    "url": "https://microwinit.com/",
    "category": "Websites"
  },
  {
    "name": "Renovation Pro",
    "tag": "",
    "url": "https://renovationpro.com.au/",
    "category": "Websites"
  },
  {
    "name": "Hillpine Consulting",
    "tag": "",
    "url": "https://hillpineconsulting.in/",
    "category": "Websites"
  },
  {
    "name": "Aarohi Taxi Services",
    "tag": "",
    "url": "https://aarohitaxiservice.com/",
    "category": "Websites"
  },
  {
    "name": "Satguru Accommodation",
    "tag": "",
    "url": "https://satguruspace.com/",
    "category": "Websites"
  },
  {
    "name": "Sehgal Eye Institute",
    "tag": "",
    "url": "https://sehgaleyeinstitute.com/",
    "category": "Websites"
  },
  {
    "name": "Dhakad Traders Shop",
    "tag": "",
    "url": "https://dhakadtraders.com/",
    "category": "Websites"
  },
  {
    "name": "Dhakad Paint Station",
    "tag": "",
    "url": "https://dhakadpaintstation.com/",
    "category": "Websites"
  },
  {
    "name": "Kaberee Foundation",
    "tag": "",
    "url": "https://kabereeacademy.com/",
    "category": "Websites"
  },
  {
    "name": "The Happy Life Foundation",
    "tag": "",
    "url": "https://thehappylifefoundation.org/",
    "category": "Websites"
  },
  {
    "name": "Semicon Pulse",
    "tag": "",
    "url": "https://semiconpulse.com/",
    "category": "Websites"
  },
  {
    "name": "Salcon Electronics",
    "tag": "",
    "url": "https://www.salconelectronics.com/",
    "category": "Websites"
  },
  {
    "name": "Suikaari",
    "tag": "",
    "url": "https://suikaari.com/",
    "category": "Websites"
  },
  {
    "name": "Aircuro",
    "tag": "",
    "url": "https://aircuro.com/",
    "category": "Websites"
  },
  {
    "name": "Mayrake India",
    "tag": "",
    "url": "https://www.mayrake.in/",
    "category": "Websites"
  },
  {
    "name": "Mayrake International",
    "tag": "",
    "url": "https://www.mayrake.com/",
    "category": "Websites"
  },
  {
    "name": "Hisab Kitab (Dhakad Group)",
    "tag": "",
    "url": "https://hisabkitab.dhakadgroup.com/index.php",
    "category": "Websites"
  },
  {
    "name": "Tracker Ghostifier",
    "tag": "Privacy Tracker Blocker",
    "url": "https://chromewebstore.google.com/detail/tracker-ghostifier-%E2%80%93-priv/bnbpifcjbdmhgibiagjnmiajmphofpdk",
    "category": "Browser extensions"
  },
  {
    "name": "Clipboard History Pro",
    "tag": "Copy Paste Manager",
    "url": "https://chromewebstore.google.com/detail/clipboard-history-pro-%E2%80%93-c/fikioilipajnpadddbahpkmjgcjebidk",
    "category": "Browser extensions"
  },
  {
    "name": "Time Tracker Per Site",
    "tag": "",
    "url": "https://chromewebstore.google.com/detail/time-tracker-per-site/mnoinnpdfggpppiedidhmlhibemljmkp",
    "category": "Browser extensions"
  },
  {
    "name": "Bill Banao",
    "tag": "Vyapar Badhao",
    "url": "https://play.google.com/store/apps/details?id=com.ashawebtech.billbanao",
    "category": "Mobile apps"
  },
  {
    "name": "Rememberly",
    "tag": "Days & Memories",
    "url": "https://play.google.com/store/apps/details?id=com.ashawebtec.rememberlyapp",
    "category": "Mobile apps"
  },
  {
    "name": "DocDesk",
    "tag": "Patient Management",
    "url": "https://play.google.com/store/apps/details?id=com.ashawebtech.docdesk",
    "category": "Mobile apps"
  },
  {
    "name": "Vehicle Diary 360 India",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.ashawebtech.vehiclediary360",
    "category": "Mobile apps"
  },
  {
    "name": "ShagunKhata",
    "tag": "Track Gift & Neg",
    "url": "https://play.google.com/store/apps/details?id=com.shagunkhata.ashawebtech",
    "category": "Mobile apps"
  },
  {
    "name": "Fresh Farmse Customer App",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.freshfarmse.customerfreshfarmse",
    "category": "Mobile apps"
  },
  {
    "name": "Dhakad Paint Station Painter",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.dhakadgroup.dhakadpaintstationpainter",
    "category": "Mobile apps"
  },
  {
    "name": "Dhakad Paint Station Employee",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.dhakadgroup.dhakadpaintstationemployee",
    "category": "Mobile apps"
  },
  {
    "name": "Dhakad Uday Yojna Employee",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.dhakadenterprises.udayemployee",
    "category": "Mobile apps"
  },
  {
    "name": "Dhakad Uday Yojna Contractor",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.dhakadenterprises.udaycontractor",
    "category": "Mobile apps"
  },
  {
    "name": "Dhakad Protsahan Contractor",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.dhakadgroup.contractorprotsahan",
    "category": "Mobile apps"
  },
  {
    "name": "Dhakad Protsahan Employee",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.dhakadtraders.protsahan",
    "category": "Mobile apps"
  },
  {
    "name": "Udhar Bahi Khata",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.marketingtech.udharbahikhata",
    "category": "Mobile apps"
  },
  {
    "name": "Photo & Video Recover Pro",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.marketingtech.photorecoverpro",
    "category": "Mobile apps"
  },
  {
    "name": "Personal Notes",
    "tag": "",
    "url": "https://play.google.com/store/apps/details?id=com.marketing.personalnote",
    "category": "Mobile apps"
  }
];

export const PORTFOLIO_CATEGORIES = ["All", "Websites", "Mobile apps", "Browser extensions"];
